import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  variant = 'primary',
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full max-w-lg items-center justify-center rounded-full font-sans font-extrabold uppercase tracking-wide text-center transition-colors duration-150 ease-soft';
  const variants: Record<string, string> = {
    primary: 'bg-cta text-white shadow-md hover:bg-cta-strong',
    outline: 'bg-transparent text-cta border-2 border-cta hover:bg-cta hover:text-white'
  };
  const sizes: Record<string, string> = {
    md: 'px-6 py-3.5 text-sm md:text-base',
    lg: 'px-8 py-4 text-base md:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-186" data-mp="138wcaflvd4ds">
      {children}
    </a>;
}